import type { BannerContentVariant } from "@vega-api/generated/types/bannerContentVariant";
import { NoticeType } from "@vega-core/components/Notice/Notice";

const VARIANT_TO_NOTICE_TYPE: Record<BannerContentVariant, NoticeType> = {
  default: NoticeType.DEFAULT,
  success: NoticeType.SUCCESS,
  warning: NoticeType.WARNING,
  error: NoticeType.ERROR,
  pending: NoticeType.PENDING,
  brand: NoticeType.BRAND,
};

export const resolveBannerNoticeType = (
  variant?: BannerContentVariant,
): NoticeType =>
  variant ? VARIANT_TO_NOTICE_TYPE[variant] : NoticeType.DEFAULT;
